export const formatVnd = (n?: number | null): string =>
  n == null || isNaN(n as number)
    ? ''
    : new Intl.NumberFormat('vi-VN').format(Math.round(n as number)) + ' ₫';

export const parseVnd = (s?: string): number | undefined => {
  if (s == null) return undefined;
  const digits = String(s).replace(/[^\d]/g, '');
  return digits ? Number(digits) : undefined;
};
